export const manifest = {
  screens: {
    scr_iu9j2p: { name: "Welcome", route: "/", state: {"currentScreen":"welcome","showSplash":false}, position: {"x":1560,"y":220} },
    scr_e07lt1: { name: "Login", route: "/", state: {"currentScreen":"login","showSplash":false}, position: {"x":2960,"y":220} },
    scr_4vapab: { name: "Register", route: "/", state: {"currentScreen":"register","showSplash":false}, position: {"x":4360,"y":220} },
    scr_wrz67q: { name: "Forgot Password", route: "/", state: {"currentScreen":"forgot-password","showSplash":false}, position: {"x":5760,"y":220} },
    scr_b9yjuk: { name: "OTP Verification", route: "/", state: {"currentScreen":"otp-verification","showSplash":false}, position: {"x":7160,"y":220} },
    scr_z76uy4: { name: "Reset Password", route: "/", state: {"currentScreen":"reset-password","showSplash":false}, position: {"x":8560,"y":220} },
    scr_o6jsmb: { name: "Dashboard", route: "/", state: {"currentScreen":"dashboard","showSplash":false}, position: {"x":160,"y":2200} },
    scr_d0ue79: { name: "Product Catalogue", route: "/", state: {"currentScreen":"products","showSplash":false}, position: {"x":160,"y":4180} },
    scr_8ahxof: { name: "Product Detail", route: "/", state: {"currentScreen":"product-detail","showSplash":false}, position: {"x":1560,"y":4180} },
    scr_0mg62q: { name: "Plan Selection", route: "/", state: {"currentScreen":"plan-selection","showSplash":false}, position: {"x":2960,"y":4180} },
    scr_d48fpq: { name: "Wallet", route: "/", state: {"currentScreen":"wallet","showSplash":false}, position: {"x":160,"y":6160} },
    scr_zru0hd: { name: "Fund Wallet", route: "/", state: {"currentScreen":"fund-wallet","showSplash":false}, position: {"x":1560,"y":6160} },
    scr_dxkto6: { name: "Transfer Money", route: "/", state: {"currentScreen":"transfer","showSplash":false}, position: {"x":2960,"y":6160} },
    scr_pt9la8: { name: "Transaction Detail", route: "/", state: {"currentScreen":"transaction-detail","showSplash":false}, position: {"x":4360,"y":6160} },
    scr_x95e78: { name: "Card Settings", route: "/", state: {"currentScreen":"card-settings","showSplash":false}, position: {"x":160,"y":8140} },
    scr_naatzs: { name: "Policy History", route: "/", state: {"currentScreen":"policies","showSplash":false}, position: {"x":160,"y":10120} },
    scr_x7nc2h: { name: "Claims", route: "/", state: {"currentScreen":"claims","showSplash":false}, position: {"x":1560,"y":10120} },
    scr_452ge1: { name: "GoalGuard Claim", route: "/", state: {"currentScreen":"goalguard-claim","showSplash":false}, position: {"x":2960,"y":10120} },
    scr_v9ay5u: { name: "Future Scholar Claim", route: "/", state: {"currentScreen":"future-scholar-claim","showSplash":false}, position: {"x":4360,"y":10120} },
    scr_73jq9i: { name: "Notifications", route: "/", state: {"currentScreen":"notifications","showSplash":false}, position: {"x":160,"y":16060} },
    scr_g4ugos: { name: "Profile", route: "/", state: {"currentScreen":"profile","showSplash":false}, position: {"x":160,"y":12100} },
    scr_5o341k: { name: "Edit Profile", route: "/", state: {"currentScreen":"edit-profile","showSplash":false}, position: {"x":1560,"y":12100} },
    scr_ceiaga: { name: "KYC Verification", route: "/", state: {"currentScreen":"kyc","showSplash":false}, position: {"x":2960,"y":12100} },
    scr_1gyixs: { name: "Bank Accounts", route: "/", state: {"currentScreen":"bank-accounts","showSplash":false}, position: {"x":4360,"y":12100} },
    scr_37fsd9: { name: "Referral Program", route: "/", state: {"currentScreen":"referral-program","showSplash":false}, position: {"x":160,"y":14080} },
    scr_slw3sg: { name: "Change PIN", route: "/", state: {"currentScreen":"change-pin","showSplash":false}, position: {"x":1560,"y":14080} },
    scr_cncebk: { name: "Two-Factor Auth", route: "/", state: {"currentScreen":"two-factor-auth","showSplash":false}, position: {"x":2960,"y":14080} },
    scr_0efbkf: { name: "Live Chat", route: "/", state: {"currentScreen":"live-chat","showSplash":false}, position: {"x":160,"y":18040} },
    scr_vdj8fv: { name: "Help Center", route: "/", state: {"currentScreen":"help-center","showSplash":false}, position: {"x":1560,"y":18040} },
    scr_vwge4z: { name: "Report Problem", route: "/", state: {"currentScreen":"report-problem","showSplash":false}, position: {"x":2960,"y":18040} },
    scr_j6y3w8: { name: "AI Assistant", route: "/", state: {"currentScreen":"ai-assistant","showSplash":false}, position: {"x":4360,"y":18040} },
    scr_90pwsq: { name: "Admin Panel", route: "/", state: {"viewMode":"admin","showSplash":false}, position: {"x":160,"y":20020} },
    scr_en3fyt: { name: "Landing Page", route: "/", state: {"viewMode":"landing","showSplash":false}, position: {"x":160,"y":220} },
  },
  sections: {
    sec_5ujemi: { name: "Landing & Authentication", x: 0, y: 0, width: 9920, height: 1180 },
    sec_09o9i1: { name: "Dashboard & Main", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_osg8va: { name: "Products & Plans", x: 0, y: 3960, width: 4320, height: 1180 },
    sec_865p3e: { name: "Wallet & Transactions", x: 0, y: 5940, width: 5720, height: 1180 },
    sec_eagldg: { name: "Cards", x: 0, y: 7920, width: 1520, height: 1180 },
    sec_n7281n: { name: "Insurance & Claims", x: 0, y: 9900, width: 5720, height: 1180 },
    sec_asm8o9: { name: "Profile & Account", x: 0, y: 11880, width: 5720, height: 1180 },
    sec_73bv60: { name: "Settings & Security", x: 0, y: 13860, width: 4320, height: 1180 },
    sec_rrxvkd: { name: "Notifications", x: 0, y: 15840, width: 1520, height: 1180 },
    sec_n862ck: { name: "Support & Help", x: 0, y: 17820, width: 5720, height: 1180 },
    sec_pstg6j: { name: "Admin", x: 0, y: 19800, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_5ujemi", children: [
      { kind: "screen", id: "scr_en3fyt" },
      { kind: "screen", id: "scr_iu9j2p" },
      { kind: "screen", id: "scr_e07lt1" },
      { kind: "screen", id: "scr_4vapab" },
      { kind: "screen", id: "scr_wrz67q" },
      { kind: "screen", id: "scr_b9yjuk" },
      { kind: "screen", id: "scr_z76uy4" },
    ] },
    { kind: "section", id: "sec_09o9i1", children: [
      { kind: "screen", id: "scr_o6jsmb" },
    ] },
    { kind: "section", id: "sec_osg8va", children: [
      { kind: "screen", id: "scr_d0ue79" },
      { kind: "screen", id: "scr_8ahxof" },
      { kind: "screen", id: "scr_0mg62q" },
    ] },
    { kind: "section", id: "sec_865p3e", children: [
      { kind: "screen", id: "scr_d48fpq" },
      { kind: "screen", id: "scr_zru0hd" },
      { kind: "screen", id: "scr_dxkto6" },
      { kind: "screen", id: "scr_pt9la8" },
    ] },
    { kind: "section", id: "sec_eagldg", children: [
      { kind: "screen", id: "scr_x95e78" },
    ] },
    { kind: "section", id: "sec_n7281n", children: [
      { kind: "screen", id: "scr_naatzs" },
      { kind: "screen", id: "scr_x7nc2h" },
      { kind: "screen", id: "scr_452ge1" },
      { kind: "screen", id: "scr_v9ay5u" },
    ] },
    { kind: "section", id: "sec_asm8o9", children: [
      { kind: "screen", id: "scr_g4ugos" },
      { kind: "screen", id: "scr_5o341k" },
      { kind: "screen", id: "scr_ceiaga" },
      { kind: "screen", id: "scr_1gyixs" },
    ] },
    { kind: "section", id: "sec_73bv60", children: [
      { kind: "screen", id: "scr_37fsd9" },
      { kind: "screen", id: "scr_slw3sg" },
      { kind: "screen", id: "scr_cncebk" },
    ] },
    { kind: "section", id: "sec_rrxvkd", children: [
      { kind: "screen", id: "scr_73jq9i" },
    ] },
    { kind: "section", id: "sec_n862ck", children: [
      { kind: "screen", id: "scr_0efbkf" },
      { kind: "screen", id: "scr_vdj8fv" },
      { kind: "screen", id: "scr_vwge4z" },
      { kind: "screen", id: "scr_j6y3w8" },
    ] },
    { kind: "section", id: "sec_pstg6j", children: [
      { kind: "screen", id: "scr_90pwsq" },
    ] },
  ],
}
